import { useRegistrationNumber } from './RegistrationNumber.hook';

import { VehicleRegistrationLookupForm } from '../subcomponents/VehicleRegistrationLookupForm/VehicleRegistrationLookupForm';

import { Text } from '../../../../../../../components/ToolkitV2/Text/Text';
import { Spacer } from 'helpers/genericStyles';

const ValueCar = () => {
  const { onSubmit, initialRegistrationNumber } = useRegistrationNumber();

  return (
    <>
      <Text forwardedAs="h2" size="L18" weight="bold">
        How much is your car worth?
      </Text>
      <Spacer marginBottom="S8" />
      <Text size="M16">
        Get a FREE instant car valuation backed by data from thousands of
        vehicles.
      </Text>
      <Spacer marginBottom="M16" />
      <VehicleRegistrationLookupForm
        onSubmitCallback={onSubmit}
        initialRegistrationNumber={initialRegistrationNumber}
      />
    </>
  );
};

export { ValueCar };
